import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Group_Interface, General_Group_Interface } from 'src/app/Interface/General_Group_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DorehAmoozeshiService } from 'src/app/Service/DorehAmoozeshi/DorehAmoozeshi.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SarFaslAmozeshiService } from 'src/app/Service/SarFaslAmozeshi/SarFaslAmozeshi.service';

@Component({
  selector: 'app-DorehAmoozeshiEdit',
  templateUrl: './DorehAmoozeshiEdit.component.html',
  styleUrls: ['./DorehAmoozeshiEdit.component.scss']
})
export class DorehAmoozeshiEditComponent implements OnInit {


  Token:String=""
  EditRecord:Number

  constructor(
    private SarFaslAmozeshi_Service:SarFaslAmozeshiService,
    private DorehAmoozeshi_Service:DorehAmoozeshiService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditDorehAmoozeshi=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      GroupId:new FormControl("0",Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(this.Token,26).subscribe(
      data=>{
        this.ReadData_SarFaslAmozeshi()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

  DataList_SarFaslAmozeshi:Array<General_Interface>=[]
  ReadData_SarFaslAmozeshi(){
    this.SarFaslAmozeshi_Service.GetActiveList(this.Token).subscribe(
      data=>{
        this.DataList_SarFaslAmozeshi=data

        this.DorehAmoozeshi_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
            this.get_Form_GroupId().setValue(data.group_id)

          }
        )
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

    //#region  Form Add

    EditDorehAmoozeshi:FormGroup;

    get_Form_Id(){
      return this.EditDorehAmoozeshi.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditDorehAmoozeshi.get('Title') as FormControl;
    }

    get_Form_GroupId(){
      return this.EditDorehAmoozeshi.get('GroupId') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditDorehAmoozeshi(){
      if(this.get_Form_GroupId().value=="0")
      {
        this.Alertify_Service.ErrorMessage("Select the training syllabus.")
      }
      else{
        var Record:General_Group_Interface =Empty_General_Group_Interface()
        Record.id=this.get_Form_Id().value
        Record.title=this.get_Form_Title().value
        Record.group_id=Number(this.get_Form_GroupId().value)
        this.InProccessing=true
        this.DorehAmoozeshi_Service.EditDorehAmoozeshi(Record,this.Token).subscribe(
          data=>{
            this.InProccessing=false
            if(data.id==-2){
              this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
            }
            else{

              this.Alertify_Service.SuccessMessage("Information saved successfully.")
            }
          }
        )
      }
    }



}
